import { useEffect, useState } from 'react';
import axios from 'axios';

export default function useCalendarArtistProfiles(locationId) {
  const [state, setState] = useState({ locationId: null, profiles: {} });
  useEffect(() => {
    if (!locationId) return undefined;
    let disposed = false;
    let controller;
    const refresh = async () => {
      controller?.abort();
      controller = new AbortController();
      try {
        const { data } = await axios.get('/api/calendar/artist-profiles', {
          params: { locationId }, signal: controller.signal, timeout: 10000,
        });
        if (disposed || !Array.isArray(data)) return;
        const profiles = {};
        data.forEach(profile => {
          if (profile.hasAvatar) profiles[profile.artistId] =
            `/api/calendar/artist-profiles/${encodeURIComponent(profile.artistId)}/avatar?locationId=${encodeURIComponent(locationId)}&v=${encodeURIComponent(profile.version)}`;
        });
        setState({ locationId, profiles });
      } catch (error) {
        // Avatars are optional: a failed request must never block the calendar.
        if (!disposed && !axios.isCancel(error)) setState({ locationId, profiles: {} });
      }
    };
    const onVisibility = () => { if (document.visibilityState === 'visible') refresh(); };
    refresh();
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      disposed = true;
      controller?.abort();
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [locationId]);
  return String(state.locationId) === String(locationId) ? state.profiles : {};
}
